/* eslint-disable @typescript-eslint/no-empty-interface */
// import original module declarations
import { AgnosticTokens, CoreInternalTokens, CottagesTokens, FincallorcaTokens, HoseasonsTokens, NovasolOwnerTokens, NovasolTokens, } from '@awaze/design-system.design-tokens';
import 'styled-components';
export const AgnosticTheme = AgnosticTokens;
export const CottagesTheme = CottagesTokens;
export const HoseasonsTheme = HoseasonsTokens;
export const NovasolTheme = NovasolTokens;
export const FincallorcaTheme = FincallorcaTokens;
export const NovasolOwnerTheme = NovasolOwnerTokens;
export const DansommerTheme = AgnosticTokens;
export const CoreInternalTheme = CoreInternalTokens;
const allThemes = {
    agnostic: AgnosticTheme,
    awaze: AgnosticTheme,
    'cottages.com': CottagesTheme,
    hoseasons: HoseasonsTheme,
    novasol: NovasolTheme,
    fincallorca: FincallorcaTheme,
    novasolOwner: NovasolOwnerTheme,
    coreInternal: CoreInternalTheme,
    dansommer: DansommerTheme,
};
export const getTheme = (brandName = 'agnostic') => {
    return allThemes[brandName] ?? AgnosticTheme;
};
//# sourceMappingURL=theme.js.map